const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export default function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const unitIndex = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${parseFloat((bytes / 1024 ** unitIndex).toFixed(decimals))} ${units[unitIndex]}`;
}
